import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyLoad from 'react-lazyload';
import kebabCase from 'lodash/kebabCase';
import TabNav from '../../TabNav';
import Carousel from '../../Carousel';
import RichText from '../../Prismic/RichText';
import Button from 'wonderbly-components/lib/Button';
import cx from 'classnames';
import { prismicImage } from 'src/common/utils/prismic-image';

import './Slider.scss';

class Slider extends Component {
  constructor() {
    super();
    this.state = {
      currentSlideIndex: 0,
    };
  }
  updateSlideIndex = index => () => {
    if (this.state.currentSlideIndex !== index) {
      this.setState({
        currentSlideIndex: index,
      });
    }
  };
  render() {
    return (
      <section
        className={cx('product-information-slider', {
          'product-information-slider--reversed': this.props.isReversed,
        })}
        id={this.props.id}>
        <div className="product-information">
          <div className="container-guttered">
            <div className="product-information-wrapper">
              <div className="product-information-carousel-wrapper">
                <Carousel
                  currentIndex={this.state.currentSlideIndex}
                  updateSlideIndex={this.updateSlideIndex}
                  group="product-information"
                  disableNavigation
                  disablePagination>
                  {this.props.items.map(item => (
                    <div
                      className="product-information-carousel-slide"
                      key={`slide-${kebabCase(item.tabTitle)}`}>
                      <LazyLoad>
                        <img
                          src={prismicImage(item.image)}
                          alt=""
                          width="100%"
                          style={{ pointerEvents: 'none' }}
                        />
                      </LazyLoad>
                    </div>
                  ))}
                </Carousel>
              </div>
              <div className="product-information-content-wrapper">
                <div className="product-information-nav">
                  <TabNav
                    currentIndex={this.state.currentSlideIndex}
                    handleClick={this.updateSlideIndex}
                    items={this.props.items.map(item => item.tabTitle)}
                  />
                </div>
                <div className="product-information-content">
                  {this.props.items.map((item, index) => (
                    <div
                      className={cx('product-information-content-slide', {
                        active: this.state.currentSlideIndex === index,
                      })}
                      key={`content-item-${kebabCase(item.tabTitle)}`}>
                      <h3 className="text-giga" data-animate-text="first">
                        {item.title}
                      </h3>
                      <RichText
                        fields={item.description}
                        animateText="second"
                      />
                      {this.props.link && this.props.cta && (
                        <Button
                          colour="green"
                          data-animate-text="third"
                          onClick={this.props.handleClick}
                          raised>
                          {this.props.cta}
                        </Button>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

Slider.propTypes = {
  id: PropTypes.string.isRequired,
  cta: PropTypes.string,
  link: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({
    image: PropTypes.object.isRequired,
    tabTitle: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.array.isRequired,
  })),
  isReversed: PropTypes.bool,
};

export default Slider;



// WEBPACK FOOTER //
// ./src/client/js/view/components/ProductInformation/Slider/Slider.js